import React from 'react';
import styled from '@emotion/styled';

import dashboardIcon from './svg/dashboard.svg';
import backIcon from './svg/back.svg';
import crownIcon from './svg/crown.svg';
import magnifyingGlassIcon from './svg/magnifying-glass.svg';
import exportIcon from './svg/exports.svg';

export enum Icons {
    BACK = 'back',
    DASHBOARD = 'dashboard',
    CROWN = 'crown',
    MAGNIFYING_GLASS = 'magnifying-glass',
    EXPORT = 'export',
}

type IconSize = 'small' | 'medium';

type Props = {
    icon: Icons;
    size?: IconSize;
};

const Image = styled.img<{ size: IconSize }>`
    width: ${({ size }) => (size === 'small' ? '13px' : '24px')};
    max-width: ${({ size }) => (size === 'small' ? '15px' : '24px')};
    max-height: ${({ size }) => (size === 'small' ? '15px' : '24px')};
    display: block;
    margin-right: ${({ theme }) => theme.spacing[2]};
`;

const nameToSvgMap: Record<Icons, string> = {
    [Icons.BACK]: backIcon,
    [Icons.DASHBOARD]: dashboardIcon,
    [Icons.CROWN]: crownIcon,
    [Icons.MAGNIFYING_GLASS]: magnifyingGlassIcon,
    [Icons.EXPORT]: exportIcon,
};

const Icon: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
    icon,
    size = 'small',
    ...otherProps
}: Props) => {
    return <Image src={nameToSvgMap[icon]} alt={`${icon} icon`} size={size} {...otherProps} />;
};

export default Icon;
